import { DsButton as e, DsDialog as t, DsIconButton as n, DsPlainButton as r, DsTooltip as i, surfaceStyles as a, useDsTooltipTrigger as o } from "@frontends/ds";
import { Fragment as s, useCallback as c, useEffect as l, useId as u, useLayoutEffect as d, useRef as f, useState as p } from "react";
import { useTranslation as m } from "react-i18next";
import { Fragment as h, jsx as g, jsxs as _ } from "react/jsx-runtime";
import { cn as v } from "@frontends/util-cn";
import { tv as y } from "tailwind-variants";
import { withSign as b } from "@frontends/util-utils";
import { DsIcon as x } from "@frontends/ds-icons";
var S = {
	alertDialog: {
		cancel: "Cancel",
		confirm: "Confirm"
	},
	floatingPanel: {
		collapse: "Collapse panel",
		expand: "Expand panel"
	},
	tradingDirection: {
		buy: "BUY",
		long: "LONG",
		sell: "SELL",
		short: "SHORT"
	}
}, C = "ui-kit";
//#endregion
//#region src/lib/i18n/useComponentTranslation.ts
function w(e, t) {
	let n = t.split(".").reduce((e, t) => {
		if (e && typeof e == "object") return e[t];
	}, e);
	return typeof n == "string" ? n : t;
}
var T = {
	t: ((e) => w(S, e)),
	i18n: null,
	ready: !0
};
function E() {
	try {
		let e = m(C);
		return e.ready ? e : T;
	} catch {
		return T;
	}
}
//#endregion
//#region src/lib/components/AlertDialog/UiKitAlertDialog.tsx
function D({ description: n, children: r, onConfirm: i, onCancel: a, onOpenChange: o, open: s, confirmLabel: c, cancelLabel: l, confirmTone: u = "danger", isConfirmLoading: d = !1, isConfirmDisabled: p = !1, isDismissable: m = !0, showClose: v = !0, size: y = "sm", ...b }) {
	let { t: x } = E(), S = n != null || r != null, C = s === !1, w = f(!1), T = (e) => {
		!e && !w.current && a?.(), e || (w.current = !1), o?.(e);
	};
	return /* @__PURE__ */ g(t, {
		...b,
		role: "alertdialog",
		isOpen: s,
		size: y,
		isDismissable: m,
		showClose: v,
		onOpenChange: T,
		footer: (t) => /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ g(e, {
			variant: "secondary",
			size: "lg",
			onPress: t,
			children: l ?? x("alertDialog.cancel")
		}), /* @__PURE__ */ g(e, {
			variant: u === "danger" ? "destructive" : "primary",
			size: "lg",
			isPending: d,
			isDisabled: p,
			onPress: () => {
				C || (w.current = !0, i?.(), t());
			},
			children: c ?? x("alertDialog.confirm")
		})] }),
		children: S ? /* @__PURE__ */ _(h, { children: [n, r] }) : null
	});
}
//#endregion
//#region src/lib/components/DataCell/UiKitDataCell.tsx
var O = y({
	base: "truncate font-sans font-medium uppercase text-textSecondary",
	variants: { size: {
		sm: "text-xs",
		md: "text-sm",
		lg: "text-sm"
	} },
	defaultVariants: { size: "md" }
}), k = y({
	base: "truncate font-mono font-medium tabular-nums",
	variants: {
		tone: {
			default: "text-textPrimary",
			positive: "text-tradingBid",
			negative: "text-tradingAsk"
		},
		size: {
			sm: "text-sm",
			md: "text-base",
			lg: "text-xl"
		}
	},
	defaultVariants: {
		tone: "default",
		size: "md"
	}
}), A = "—";
function j(e) {
	return e == null || e === "" || typeof e == "boolean";
}
function M({ label: e, value: t, delta: n, tone: r, size: i, containerClassName: a, labelClassName: o, valueClassName: s }) {
	let c = typeof e == "string" ? e : void 0, l = j(t), u = !l && (typeof t == "string" || typeof t == "number") ? String(t) : void 0, d = /* @__PURE__ */ g("span", {
		className: v(k({
			tone: r,
			size: i
		}), l && "text-textTertiary", s),
		title: u,
		children: l ? A : t
	});
	return /* @__PURE__ */ _("div", {
		className: v("flex min-w-0 flex-col", a),
		children: [/* @__PURE__ */ g("span", {
			className: v(O({ size: i }), o),
			title: c,
			children: e
		}), n ? /* @__PURE__ */ _("div", {
			className: "flex flex-wrap items-baseline gap-x-2",
			children: [d, n]
		}) : d]
	});
}
//#endregion
//#region src/lib/components/DeltaIndicator/UiKitDeltaIndicator.tsx
var N = [
	"positive",
	"negative",
	"neutral"
], P = [
	"arrow",
	"sign",
	"none"
], F = [
	"sm",
	"md",
	"lg"
], I = [
	"trading",
	"semantic",
	"muted"
], L = ["medium", "regular"], R = "—", z = "—", B = {
	positive: "M5 0 10 10H0Z",
	negative: "M5 10 0 0h10Z"
}, V = {
	positive: "+",
	negative: "−",
	neutral: ""
}, H = y({
	base: "inline-flex items-baseline gap-1 whitespace-nowrap tabular-nums",
	variants: {
		variant: {
			trading: "font-mono",
			semantic: "",
			muted: "font-mono text-textSecondary"
		},
		trend: {
			positive: "",
			negative: "",
			neutral: "text-textSecondary"
		},
		size: {
			sm: "text-sm",
			md: "text-base",
			lg: "text-xl"
		},
		weight: {
			medium: "font-medium",
			regular: "font-normal"
		}
	},
	compoundVariants: [
		{
			variant: "trading",
			trend: "positive",
			className: "text-tradingBid"
		},
		{
			variant: "trading",
			trend: "negative",
			className: "text-tradingAsk"
		},
		{
			variant: "semantic",
			trend: "positive",
			className: "text-textSuccessSecondary"
		},
		{
			variant: "semantic",
			trend: "negative",
			className: "text-textDangerSecondary"
		}
	],
	defaultVariants: {
		size: "md",
		variant: "trading",
		weight: "medium"
	}
});
function ee({ trend: e }) {
	return /* @__PURE__ */ g("svg", {
		viewBox: "0 0 10 10",
		width: "0.65em",
		height: "0.65em",
		fill: "currentColor",
		"aria-hidden": "true",
		className: "shrink-0",
		children: /* @__PURE__ */ g("path", { d: B[e] })
	});
}
function U({ trend: e, value: t, marker: n = "arrow", size: r, variant: i, weight: a, className: o }) {
	if (!t) return /* @__PURE__ */ g("span", {
		className: v(H({
			size: r,
			variant: i,
			weight: a
		}), "text-textTertiary", o),
		children: R
	});
	let s = V[e];
	return n === "sign" ? /* @__PURE__ */ g("span", {
		className: v(H({
			trend: e,
			size: r,
			variant: i,
			weight: a
		}), o),
		children: b(t, s)
	}) : /* @__PURE__ */ _("span", {
		className: v(H({
			trend: e,
			size: r,
			variant: i,
			weight: a
		}), o),
		children: [n === "arrow" && (e === "neutral" ? /* @__PURE__ */ g("span", {
			"aria-hidden": "true",
			children: z
		}) : /* @__PURE__ */ g(ee, { trend: e })), /* @__PURE__ */ _("span", { children: [s && /* @__PURE__ */ g("span", {
			className: "sr-only",
			children: s
		}), t] })]
	});
}
//#endregion
//#region src/lib/components/EmptyState/UiKitEmptyState.tsx
function W({ title: t, description: n, icon: i, actionLabel: a, onAction: o, actionIcon: s, actionButton: c = "primary", align: l = "top", className: u, ...d }) {
	return /* @__PURE__ */ _("div", {
		className: v("flex flex-col items-center gap-6 text-center", l === "center" && "min-h-0 flex-1 justify-center px-6", u),
		...d,
		children: [
			i && /* @__PURE__ */ g("div", {
				className: "flex size-12 items-center justify-center rounded-xl bg-backgroundMuted",
				children: /* @__PURE__ */ g(x, {
					name: i,
					size: "md",
					className: "text-textSecondary"
				})
			}),
			/* @__PURE__ */ _("div", {
				className: "flex flex-col items-center gap-2",
				children: [/* @__PURE__ */ g("p", {
					className: "text-lg font-medium text-textPrimary wrap-anywhere",
					children: t
				}), n && /* @__PURE__ */ g("p", {
					className: "text-sm text-textSecondary wrap-anywhere",
					children: n
				})]
			}),
			a && (c === "plain" ? /* @__PURE__ */ g(r, {
				variant: "primary",
				iconStart: s,
				onPress: o,
				children: a
			}) : /* @__PURE__ */ g(e, {
				variant: "primary",
				size: "md",
				iconStart: s,
				onPress: o,
				children: a
			}))
		]
	});
}
//#endregion
//#region src/lib/components/FloatingPanel/hooks/useDraggable.ts
var G = "button, input, select, textarea, label, [role=\"button\"]", te = 16;
function K(e, t, n) {
	return Math.min(Math.max(e, t), n);
}
function q(e) {
	return getComputedStyle(e).direction === "rtl";
}
function J(e, t) {
	switch (e) {
		case "top-start": return t ? "top-right" : "top-left";
		case "top-end": return t ? "top-left" : "top-right";
		case "bottom-start": return t ? "bottom-right" : "bottom-left";
		case "bottom-end": return t ? "bottom-left" : "bottom-right";
		default: return e;
	}
}
function Y(e) {
	return e === "top-right" || e === "bottom-right";
}
function X(e) {
	return typeof e == "number" ? {
		x: e,
		y: e
	} : e;
}
function Z(e, t, n, r, i) {
	if (typeof t == "object") return {
		left: t.x,
		top: t.y
	};
	let a = e.offsetHeight, o = t === "top-left" || t === "top-right" ? r.y : n.height - a - r.y;
	return Y(t) ? i ? {
		left: n.width - e.offsetWidth - r.x,
		top: o
	} : {
		right: r.x,
		top: o
	} : {
		left: r.x,
		top: o
	};
}
function Q({ enabled: e, initialPosition: t, container: n = null, ignoreSelector: r = G, margin: i = te, wholeElementHandle: a = !1 }) {
	let o = f(null), s = f(null), c = f(t), u = f(X(i)), [m, h] = p(!1);
	return d(() => {
		let e = o.current;
		if (!e) return;
		let t = e.ownerDocument.defaultView ?? window, r = u.current, i = J(c.current, q(e)), { left: a = 0, right: s, top: l } = Z(e, i, n ? {
			width: n.clientWidth,
			height: n.clientHeight
		} : {
			width: t.innerWidth,
			height: t.innerHeight
		}, r, !!n);
		s === void 0 ? (e.style.left = `${a}px`, e.style.right = "auto") : (e.style.left = "auto", e.style.right = `${s}px`), e.style.top = `${l}px`;
		let d = n ? () => {
			if (!n) return;
			let t = Math.max(0, n.clientWidth - e.offsetWidth), r = Math.max(0, n.clientHeight - e.offsetHeight);
			e.style.left = `${K(e.offsetLeft, 0, t)}px`, e.style.right = "auto", e.style.top = `${K(e.offsetTop, 0, r)}px`;
		} : () => {
			let n = e.getBoundingClientRect(), r = Math.max(0, t.innerWidth - e.offsetWidth), a = Math.max(0, t.innerWidth - e.offsetWidth), o = Math.max(0, t.innerHeight - e.offsetHeight);
			if (Y(i)) {
				let r = t.innerWidth - n.right;
				e.style.right = `${K(r, 0, a)}px`, e.style.left = "auto";
			} else e.style.left = `${K(n.left, 0, r)}px`, e.style.right = "auto";
			e.style.top = `${K(n.top, 0, o)}px`;
		}, f = t.ResizeObserver, p = f === void 0 ? void 0 : new f(d);
		return n ? (p?.observe(n), p?.observe(e)) : (t.addEventListener("resize", d), p?.observe(e)), () => {
			t.removeEventListener("resize", d), p?.disconnect();
		};
	}, [n]), l(() => {
		if (!e) return;
		let t = o.current, i = a ? t : s.current;
		if (!t || !i) return;
		let l = t.ownerDocument.defaultView ?? window, u = t.ownerDocument, d = i.style.touchAction;
		i.style.touchAction = "none";
		let f = 0, p = 0, m = 0, g = 0, _ = 0, v = !1, y = 0, b = !n && Y(J(c.current, q(t))), x = (e) => {
			if (!v || e.pointerId !== y) return;
			if (e.pointerType === "mouse" && e.buttons === 0) {
				S(e);
				return;
			}
			e.preventDefault();
			let r = e.clientX - f, i = e.clientY - p, a = n ? n.clientWidth : l.innerWidth, o = n ? n.clientHeight : l.innerHeight, s = Math.max(0, a - t.offsetWidth), c = Math.max(0, a - t.offsetWidth), u = Math.max(0, o - t.offsetHeight);
			b ? (t.style.right = `${K(g - r, 0, c)}px`, t.style.left = "auto") : (t.style.left = `${K(m + r, 0, s)}px`, t.style.right = "auto"), t.style.top = `${K(_ + i, 0, u)}px`;
		}, S = (e) => {
			!v || e && e.pointerId !== y || (e && i.hasPointerCapture?.(e.pointerId) && i.releasePointerCapture(e.pointerId), v = !1, h(!1), u.removeEventListener("pointermove", x, !0), u.removeEventListener("pointerup", S, !0), u.removeEventListener("pointercancel", S, !0));
		}, C = (e) => {
			let a = e.target, o = e.button === 0;
			if (!(v || !o || a?.closest(r))) {
				if (e.preventDefault(), v = !0, y = e.pointerId, h(!0), f = e.clientX, p = e.clientY, n) m = t.offsetLeft, _ = t.offsetTop;
				else {
					let e = t.getBoundingClientRect();
					m = e.left, g = l.innerWidth - e.right, _ = e.top;
				}
				i.setPointerCapture && i.setPointerCapture(e.pointerId), u.addEventListener("pointermove", x, !0), u.addEventListener("pointerup", S, !0), u.addEventListener("pointercancel", S, !0);
			}
		};
		return i.addEventListener("pointerdown", C, !0), () => {
			S(), i.style.touchAction = d, i.removeEventListener("pointerdown", C, !0);
		};
	}, [
		e,
		n,
		a,
		r
	]), {
		panelRef: o,
		handleRef: s,
		isDragging: m
	};
}
//#endregion
//#region src/lib/components/FloatingPanel/FloatingPanel.tsx
var ne = y({
	base: "truncate",
	variants: { size: {
		xs: "text-sm",
		sm: "text-base",
		md: "text-lg",
		lg: "text-xl"
	} },
	defaultVariants: { size: "md" }
});
function re({ size: e = "md", title: t, iconElement: r, headerExtra: i, headerExtraCollapsed: o, headerBottomCollapsed: s, children: l, draggable: d = !0, initialPosition: f = "top-right", container: m, wholeElementHandle: h, ignoreSelector: y, margin: b, collapsible: x = !0, defaultCollapsed: S = !1, collapsed: C, onCollapsedChange: w, disabled: T = !1, className: D, bodyClassName: O, headerClassName: k, "aria-label": A }) {
	let { t: j } = E(), M = u(), [N, P] = p(S), F = C !== void 0, I = F ? C : N, L = c(() => {
		let e = !I;
		F || P(e), w?.(e);
	}, [
		I,
		F,
		w
	]), R = d && !T, { panelRef: z, handleRef: B, isDragging: V } = Q({
		enabled: R,
		initialPosition: f,
		container: m,
		wholeElementHandle: h,
		ignoreSelector: y,
		margin: b
	});
	return /* @__PURE__ */ _("div", {
		ref: z,
		role: "group",
		"aria-label": A,
		"aria-labelledby": A === void 0 ? M : void 0,
		inert: T,
		className: v(m ? "absolute" : "fixed", "z-floating flex flex-col min-w-[240px] select-none", a({ level: "panel" }).surface(), T && "opacity-disabled pointer-events-none", D),
		children: [
			/* @__PURE__ */ _("div", {
				ref: B,
				className: v("flex items-center justify-between gap-4 px-3 py-2", !(I && s) && "border-b border-borderSurface", "text-textPrimary", k),
				style: V ? { cursor: "grabbing" } : R ? { cursor: "grab" } : void 0,
				children: [/* @__PURE__ */ _("div", {
					className: "flex items-center gap-2 min-w-0",
					children: [r && /* @__PURE__ */ g("span", {
						className: "shrink-0 text-textSecondary",
						children: r
					}), /* @__PURE__ */ g("span", {
						id: M,
						className: ne({ size: e }),
						children: t
					})]
				}), /* @__PURE__ */ _("div", {
					className: "flex items-center gap-1.5 shrink-0",
					children: [
						i,
						I && o && /* @__PURE__ */ g("div", {
							className: "flex items-center gap-1 shrink-0",
							children: o
						}),
						x && /* @__PURE__ */ g(n, {
							size: "sm",
							name: I ? "chevron-down" : "chevron-up",
							isDisabled: T,
							onPress: L,
							"aria-expanded": !I,
							"aria-label": j(I ? "floatingPanel.expand" : "floatingPanel.collapse")
						})
					]
				})]
			}),
			I && s && /* @__PURE__ */ g("div", {
				className: "pb-2 px-3",
				children: s
			}),
			!I && /* @__PURE__ */ g("div", {
				className: v("flex flex-col", O),
				children: l
			})
		]
	});
}
//#endregion
//#region src/lib/components/HighlightedText/UiKitHighlightedText.tsx
var ie = {
	brand: "text-textBrand",
	warning: "text-textWarningPrimary",
	positive: "text-textSuccessPrimary",
	negative: "text-textDangerPrimary"
};
function $(e) {
	let t = [{
		lowered: 0,
		source: 0
	}], n = 0, r = 0;
	for (let i of e) n += i.toLowerCase().length, r += i.length, t.push({
		lowered: n,
		source: r
	});
	return t;
}
function ae({ text: e, highlight: t, className: n, tone: r = "brand", highlightClassName: i }) {
	let a = i ?? ie[r];
	if (!t) return /* @__PURE__ */ g("span", {
		className: n,
		children: e
	});
	let o = t.toLowerCase(), c = e.toLowerCase(), l = $(e), u = [], d = l[0], f = c.indexOf(o), p = f >= 0;
	for (; p;) {
		let t = f + o.length, n = l.filter((e) => e.lowered <= f), r = n[n.length - 1], i = l.find((e) => e.lowered >= t) ?? l[l.length - 1];
		r.source > d.source && u.push({
			text: e.slice(d.source, r.source),
			isHighlight: !1
		}), u.push({
			text: e.slice(r.source, i.source),
			isHighlight: !0
		}), d = i, f = c.indexOf(o, d.lowered), p = f >= 0;
	}
	return d.source < e.length && u.push({
		text: e.slice(d.source),
		isHighlight: !1
	}), /* @__PURE__ */ g("span", {
		className: n,
		children: u.map((e, t) => /* @__PURE__ */ g(s, { children: e.isHighlight ? /* @__PURE__ */ g("span", {
			className: v(a),
			children: e.text
		}) : e.text }, t))
	});
}
//#endregion
//#region src/lib/components/TradingDirection/TradingDirection.tsx
var oe = /* @__PURE__ */ function(e) {
	return e.Buy = "buy", e.Sell = "sell", e.Long = "long", e.Short = "short", e;
}({}), se = [
	"sm",
	"md",
	"lg"
], ce = y({
	base: "inline-flex w-fit shrink-0 items-center justify-center gap-1 rounded-full inset-ring-1 font-medium tracking-wide whitespace-nowrap select-none",
	variants: {
		tone: {
			bid: "bg-tradingBidMuted text-tradingBid inset-ring-tradingBidBorder",
			ask: "bg-tradingAskMuted text-tradingAsk inset-ring-tradingAskBorder",
			neutral: "bg-backgroundMuted text-textSecondary inset-ring-borderPrimary"
		},
		size: {
			sm: "px-1.5 text-xs",
			md: "px-2 py-0.5 text-sm",
			lg: "px-2.5 py-1 text-base"
		},
		showIcon: { true: "" }
	},
	compoundVariants: [
		{
			showIcon: !0,
			size: "sm",
			class: "ps-1"
		},
		{
			showIcon: !0,
			size: "md",
			class: "ps-1.5"
		},
		{
			showIcon: !0,
			size: "lg",
			class: "ps-2"
		}
	],
	defaultVariants: { size: "md" }
}), le = {
	sm: "xs",
	md: "xs",
	lg: "sm"
};
function ue({ direction: e, size: t = "md", showIcon: n = !1, isNeutral: r = !1, className: i, ...a }) {
	let { t: o } = E(), s = {
		buy: o("tradingDirection.buy", { defaultValue: "BUY" }),
		sell: o("tradingDirection.sell", { defaultValue: "SELL" }),
		long: o("tradingDirection.long", { defaultValue: "LONG" }),
		short: o("tradingDirection.short", { defaultValue: "SHORT" })
	}, c = e === "buy" || e === "long";
	return /* @__PURE__ */ _("span", {
		className: v(ce({
			tone: r ? "neutral" : c ? "bid" : "ask",
			size: t,
			showIcon: n
		}), i),
		...a,
		children: [n && /* @__PURE__ */ g(x, {
			name: c ? "arrow-up" : "arrow-down",
			size: le[t],
			"aria-hidden": !0
		}), s[e]]
	});
}
//#endregion
//#region src/lib/components/TruncatedText/UiKitTruncatedText.tsx
function de(e, t) {
	return t ? e.scrollWidth > e.clientWidth : e.scrollHeight > e.clientHeight;
}
function fe({ text: e, maxLines: t = 1, className: n }) {
	let r = o(), [a, s] = p(!1), c = t <= 1;
	function l(e) {
		s(de(e.currentTarget, c)), r.triggerProps.onMouseEnter?.(e);
	}
	return /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ g("span", {
		ref: r.triggerRef,
		...r.triggerProps,
		"aria-describedby": a ? r.triggerProps["aria-describedby"] : void 0,
		onMouseEnter: l,
		className: v("min-w-0", c ? "truncate" : "overflow-hidden break-words [display:-webkit-box] [-webkit-box-orient:vertical]", n),
		style: c ? void 0 : { WebkitLineClamp: t },
		children: e
	}), /* @__PURE__ */ g(i, {
		anchor: r.anchor,
		isOpen: a && r.anchor.state.isOpen,
		children: e
	})] });
}
//#endregion
export { P as DELTA_MARKERS, F as DELTA_SIZES, N as DELTA_TRENDS, I as DELTA_VARIANTS, L as DELTA_WEIGHTS, re as FloatingPanel, se as TRADING_DIRECTION_SIZES, ue as TradingDirection, oe as TradingDirectionType, C as UI_KIT_NAMESPACE, D as UiKitAlertDialog, M as UiKitDataCell, U as UiKitDeltaIndicator, W as UiKitEmptyState, ae as UiKitHighlightedText, fe as UiKitTruncatedText, Q as useDraggable };
